import { Navigate, Route, Routes } from 'react-router-dom';
import { Providers } from '@/components/providers';
import { LoginPage } from '@/pages/LoginPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { LevelsPage } from '@/pages/LevelsPage';
import { LessonsPage } from '@/pages/LessonsPage';
import { ExercisesPage } from '@/pages/ExercisesPage';
import { ExamsPage } from '@/pages/ExamsPage';
import { LearnersPage } from '@/pages/LearnersPage';
import { SubscriptionsPage } from '@/pages/SubscriptionsPage';
import { ConfigPage } from '@/pages/ConfigPage';
import { BookingsPage } from '@/pages/BookingsPage';
import { WhatsAppPage } from '@/pages/WhatsAppPage';
import { SpeakingPage } from '@/pages/SpeakingPage';
import { CreditsPage } from '@/pages/CreditsPage';
import { AiCostPage } from '@/pages/AiCostPage';
import { AiModelPricingPage } from '@/pages/AiModelPricingPage';
import { FinancePage } from '@/pages/FinancePage';
import { FaqPage } from '@/pages/FaqPage';
import { NotificationsPage } from '@/pages/NotificationsPage';

export default function App() {
  return (
    <Providers>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<DashboardPage />} />
        <Route path="/levels" element={<LevelsPage />} />
        <Route path="/lessons" element={<LessonsPage />} />
        <Route path="/exercises" element={<ExercisesPage />} />
        <Route path="/exams" element={<ExamsPage />} />
        <Route path="/learners" element={<LearnersPage />} />
        <Route path="/subscriptions" element={<SubscriptionsPage />} />
        <Route path="/bookings" element={<BookingsPage />} />
        <Route path="/whatsapp" element={<WhatsAppPage />} />
        <Route path="/speaking" element={<SpeakingPage />} />
        <Route path="/credits" element={<CreditsPage />} />
        <Route path="/ai-cost" element={<AiCostPage />} />
        <Route path="/ai-model-pricing" element={<AiModelPricingPage />} />
        <Route path="/finance" element={<FinancePage />} />
        <Route path="/config" element={<ConfigPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Providers>
  );
}